import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DiagnosticComponents.css';

const DiagnosticHeader = ({ student, formattedDate }) => {
  const navigate = useNavigate();

  return (
    <div className="diag-header-container">
      <div className="diag-breadcrumb">
        <span onClick={() => navigate('/admin/diagnostic-analysis')} className="breadcrumb-link">Diagnostic Analysis</span> 
        <span className="breadcrumb-separator">{'>'}</span> 
        <span className="breadcrumb-current">Student Report</span>
      </div>

      <div className="diag-header-card">
        <div className="dh-avatar">
          {student.name ? student.name.charAt(0).toUpperCase() : '?'}
        </div>
        <div className="dh-info">
          <div className="dh-name-row">
            <h1 className="dh-name">{student.name}</h1>
            <span className="dh-date-badge">Generated {formattedDate}</span>
          </div>
          <div className="dh-meta-row">
            <div className="dh-meta-item">
              <span className="dh-meta-label">Roll Number</span>
              <span className="dh-meta-value">{student.roll_number}</span>
            </div>
            <div className="dh-meta-divider"></div>
            <div className="dh-meta-item">
              <span className="dh-meta-label">Department</span>
              <span className="dh-meta-value">{student.branch}</span>
            </div>
            <div className="dh-meta-divider"></div>
            <div className="dh-meta-item">
              <span className="dh-meta-label">Assessment</span>
              <span className="dh-meta-value">{student.test_name}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticHeader;
